import React from 'react';

export default function EmailIcon(props: React.SVGAttributes<any>) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.45561 9.46026C6.73711 9.17589 7.126 9 7.55556 9H32.4444C32.874 9 33.2629 9.17589 33.5444 9.46026M6.45561 9.46026C6.17411 9.74463 6 10.1375 6 10.5714V29.4286C6 30.2964 6.69645 31 7.55556 31H32.4444C33.3036 31 34 30.2964 34 29.4286V10.5714C34 10.1375 33.8259 9.74463 33.5444 9.46026M6.45561 9.46026L17.8001 20.9204C19.0151 22.1478 20.9849 22.1478 22.1999 20.9204L33.5444 9.46026"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
